import { defineMessages } from 'react-intl'

const scope = `procurify.components.CostSummary`

export default defineMessages({
  tableAriaLabel: {
    id: `${scope}.tableAriaLabel`,
    defaultMessage: 'Cost Summary',
  },
})
